import { gql } from '@apollo/client';

const CREATE_CLIENT_GUSTO_ACCOUNT = gql`
  query CreateClientGustoAccount($clientId: String!) {
    createGustoAccount(clientId: $clientId)
      @rest(type: "Gusto", path: "gusto.json/client/:clientId") {
      redirectUrl
    }
  }
`;

export default CREATE_CLIENT_GUSTO_ACCOUNT;
